function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgBasket = function SvgBasket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    width: "512px",
    height: "512px",
    className: "",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, React.createElement("g", null, React.createElement("rect", {
    y: 19.5,
    style: {
      fill: "#CF3E13"
    },
    width: 58,
    height: 6,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("path", {
    style: {
      fill: "#F36703"
    },
    d: "M52.433,57.5H5.567C3.597,57.5,2,55.903,2,53.933V25.5h54v28.433C56,55.903,54.403,57.5,52.433,57.5   z",
    "data-original": "#556080",
    className: "",
    "data-old_color": "#556080"
  }), React.createElement("path", {
    style: {
      fill: "#F36703"
    },
    d: "M6,23.5c-0.129,0-0.261-0.025-0.388-0.078c-0.509-0.215-0.748-0.801-0.534-1.31l7.349-17.453   C12.979,3.348,14.255,2.5,15.679,2.5H18c0.552,0,1,0.447,1,1s-0.448,1-1,1h-2.321c-0.617,0-1.169,0.367-1.408,0.935L6.922,22.888   C6.761,23.271,6.39,23.5,6,23.5z",
    "data-original": "#556080",
    className: "",
    "data-old_color": "#556080"
  }), React.createElement("path", {
    style: {
      fill: "#F36703"
    },
    d: "M52,23.5c-0.39,0-0.761-0.229-0.922-0.612L43.729,5.435C43.491,4.867,42.938,4.5,42.321,4.5H40   c-0.552,0-1-0.447-1-1s0.448-1,1-1h2.321c1.423,0,2.7,0.848,3.252,2.159l7.349,17.453c0.214,0.509-0.025,1.095-0.534,1.31   C52.261,23.475,52.13,23.5,52,23.5z",
    "data-original": "#556080",
    className: "",
    "data-old_color": "#556080"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 23,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 26,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 26,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 29,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 17,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 20,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 20,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 5,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 11,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 8,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 14,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 8,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 14,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 53,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 47,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 50,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 50,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 32,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 32,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 35,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 41,
    cy: 31.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 23,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 29,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 17,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 5,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 11,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 53,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 47,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 35,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 41,
    cy: 37.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 38,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 44,
    cy: 28.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 38,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 44,
    cy: 34.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 23,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 26,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 26,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 29,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 17,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 20,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 20,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 5,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 11,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 8,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 14,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 8,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 14,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 53,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 47,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 50,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 50,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 32,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 32,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 35,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 41,
    cy: 43.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 23,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 29,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 17,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 5,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 11,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 53,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 47,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 35,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 41,
    cy: 49.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 38,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 44,
    cy: 40.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 38,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 44,
    cy: 46.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 23,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 26,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 29,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 17,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 20,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 5,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 11,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 8,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 14,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 53,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 47,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 50,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 32,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 35,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 41,
    cy: 55.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 38,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("circle", {
    style: {
      fill: "#CF3E13"
    },
    cx: 44,
    cy: 52.5,
    r: 1,
    "data-original": "#8697CB",
    className: "active-path",
    "data-old_color": "#8697CB"
  }), React.createElement("path", {
    style: {
      fill: "#904444"
    },
    d: "M37,6.5H21c-1.65,0-3-1.35-3-3v0c0-1.65,1.35-3,3-3h16c1.65,0,3,1.35,3,3v0   C40,5.15,38.65,6.5,37,6.5z",
    "data-original": "#F0C419",
    className: "",
    "data-old_color": "#F0C419"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBasket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/basket.035a741d.svg";
export { ForwardRef as ReactComponent };